import React, { useEffect } from "react";
import "./Contact.scss";
import blueGuy from '../assets/images/content/h3.png';
import { LuSend } from "react-icons/lu";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function Contact() {
    useEffect(() => {}, []);

    const onSubmit = async (event) => {
        event.preventDefault();
        const formData = new FormData(event.target);

        formData.append("access_key", process.env.REACT_APP_W3FORMS_ACCESS_KEY);

        const response = await fetch("https://api.web3forms.com/submit", {
            method: "POST",
            body: formData
        });

        const data = await response.json();

        if (data.success) {
            toast.success("Thanks for your message! We'll be in touch soon!", {
                position: "top-center",
            });
            event.target.reset();
        } else {
            console.log("Error", data);
            toast.error(data.message);
        }
    };

    return (
        <>
            <div
                className="contact-card"
            >
                <div className="row g-0" >
                    <div className="col-md-6 image-column" >
                        <img src={blueGuy} alt="" width="636" height="512" className="img-fluid" />
                    </div>
                    <div className="col-md-6 form-column">
                        <h2 className="form-subheader">We're Here to Help</h2>
                        <p className="form-description">Please fill out the form below, and we’ll get back to you shortly.</p>
                        <form onSubmit={onSubmit}>
                            <input type="text" name="name" autoComplete="name" aria-label="Your Name" required placeholder="Your Name" className="form-control mb-3" />
                            <input type="email" name="email" autoComplete="email" aria-label="Your Email" required placeholder="Your Email" className="form-control mb-3" />
                            <input type="tel" name="phone" autoComplete="tel" aria-label="Your Phone" placeholder="Your Phone" className="form-control mb-3" />
                            <textarea name="message" aria-label="Your Message" required placeholder="Your Message" className="form-control mb-3"></textarea>
                            <button className="ak-round-white-btn" type="submit">
                                Submit
                                <LuSend aria-hidden="true" />
                            </button>
                        </form>
                    </div>
                </div>
            </div>
            <ToastContainer />
        </>
    );
}
